"use client"

import React, { useMemo, useState } from "react"
import { useUbStorefrontState } from "@/store/ubStorefrontState"
import { defaultStyles, JsonView } from "react-json-view-lite"

import { BasketContext, BasketTotalData } from "@/lib/storefront/basket/basket"
import { determineBasketTotalData } from "@/lib/storefront/basket/basketHelper"

import "react-json-view-lite/dist/index.css"

import { CircleMinus, CirclePlus } from "lucide-react"

import { Button } from "@/components/ui/components"
import { cn } from "@/components/ui/helpers/utils"
import { UbBasketDebugStoryblok } from "@/components/storyblok/component-types"

interface BasketDebugProps {
  basketContext: BasketContext
  blok: UbBasketDebugStoryblok
}

export default function BasketDebugClient(props: BasketDebugProps) {
  const isB2B = props.basketContext.isB2B

  const [expanded, setExpanded] = useState<boolean>(false)

  const { basketData, basketLineItems, basketPromotionCodes } = useUbStorefrontState()

  const basketTotalData: BasketTotalData = useMemo(() => {
    return determineBasketTotalData(isB2B, basketData, basketLineItems, basketPromotionCodes)
  }, [basketData, basketLineItems, basketPromotionCodes, isB2B])

  function toggleExpanded() {
    setExpanded(!expanded)
  }

  return (
    <>
      {basketData && basketLineItems && (
        <div className={"relative z-[200]"}>
          <div
            className={cn("fixed right-0 top-0 h-auto min-h-8 min-w-8 overflow-auto sm:w-[32rem]", {
              "w-12": !expanded,
            })}
          >
            <Button
              size={"smNoGrow"}
              variant={"ghost"}
              onClick={toggleExpanded}
              className={"absolute  right-1 top-1 size-6 p-1"}
            >
              <>{expanded ? <CircleMinus className={"size-4"} /> : <CirclePlus className={"size-4"} />}</>
            </Button>
            <div
              className={cn("block", {
                hidden: !expanded,
              })}
            >
              <p className={"bg-[#eee] pl-3 text-xs"}>Raw Basket Data</p>
              <JsonView data={basketData} shouldExpandNode={() => false} style={defaultStyles} />
              <p className={"bg-[#eee] pl-3 text-xs"}>Extracted Basket Total Data</p>
              <JsonView data={basketTotalData} shouldExpandNode={() => false} style={defaultStyles} />
              <p className={"bg-[#eee] pl-3 text-xs"}>Extracted Basket Line Items</p>
              <JsonView data={basketLineItems} shouldExpandNode={() => false} style={defaultStyles} />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
